import MyOvertimeView from "../../features/overtime/MyOvertimeView";

const MyOvertimePage = () => <MyOvertimeView />;

export default MyOvertimePage;
